export default __webpack_public_path__ + "static/media/finlauson.e39b99aa.svg";